async function getNextPage(url, feedSelector, itemSelector) {
    const res = await fetch(url);

    if (!res.ok) {
        throw new Error("Failed to fetch page");
    }

    const nextPageHtml = await res.text();
    const parser = new DOMParser();
    const parsed = parser.parseFromString(nextPageHtml, "text/html");
    const nextFeed = parsed.querySelector(feedSelector);
    const items = nextFeed ? Array.from(nextFeed.querySelectorAll(itemSelector)) : [];
    const nextLink = parsed.querySelector('link[rel="next"]')?.getAttribute("href");

    return { items, nextLink };
}

function dispatchAppendedContent(feed) {
    document.dispatchEvent(new CustomEvent("codex:content-appended", {
        detail: { container: feed }
    }));
}

function createInfiniteScroller(feed) {
    let nextLink = document.querySelector('link[rel="next"]')?.getAttribute("href");
    if (!nextLink) return;

    const feedSelector = feed.dataset.feedSelector || ".gh-postfeed";
    const itemSelector = feed.dataset.itemSelector || ".post";
    let observer;
    let loading = false;

    const observeLastItem = () => {
        const lastItem = feed.querySelector(`${itemSelector}:last-of-type`);

        if (!lastItem) {
            observer?.disconnect();
            return;
        }

        observer.disconnect();
        observer.observe(lastItem);
    };

    observer = new IntersectionObserver(async entries => {
        const entry = entries[0];
        if (!entry?.isIntersecting || loading || !nextLink) return;

        loading = true;

        try {
            const { items, nextLink: incomingNextLink } = await getNextPage(nextLink, feedSelector, itemSelector);

            items.forEach(item => {
                feed.appendChild(item);
            });

            dispatchAppendedContent(feed);

            nextLink = incomingNextLink;

            if (!nextLink) {
                observer.disconnect();
                return;
            }

            observeLastItem();
        } catch (error) {
            console.error(error);
            observer.disconnect();
        } finally {
            loading = false;
        }
    }, {
        rootMargin: "200px"
    });

    observeLastItem();
}

export default function infiniteScroll(root = document) {
    root.querySelectorAll("[data-infinite-scroll]").forEach(feed => {
        if (feed.dataset.infiniteBound === "1") return;
        feed.dataset.infiniteBound = "1";
        createInfiniteScroller(feed);
    });
}
